<template>
  <mdb-container class="gp-has-header">
    <div v-show="views.list">
      <data-table ref="productList" :add-handler="addProduct"
                  :cardConfig="cardConfig"
                  :click-handler="showProduct"
                  add-label="New Product"
                  data-source="/product/list"
                  page-title="Products"
                  show-add-button
                  view-as-cards/>
    </div>

    <div v-if="views.product">
      <div class="text-left">
        <mdb-btn icon="arrow-left" @click="toggleView('list')">Main</mdb-btn>
      </div>

      <mdb-card class="mb-4">
        <mdb-card-body class="mb-1 text-left">
          <form id="input-form" novalidate @submit.prevent="checkForm">
            <div class="form-row">
              <div class="col-md-2">
                <mdb-input v-model="editingProduct.id" disabled label="ID"/>
              </div>
              <div class="col-md-8">
                <!--<gp-select :dataObj="editingProduct" :possible-values="categories" :required="true"
                           label="Category" propertyName="category"/> -->
                <h6>Category</h6>
                <treeselect v-model="editingProduct.category" :multiple="false" :options="categories" />

              </div>
              <div class="col-md-2">
                <input id="is-disabled" v-model="editingProduct.disabled" aria-label="Disabled?"
                       class="form-control form-check-input"
                       type="checkbox"/>
                <label for="is-disabled">Disabled</label>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-6">
                <mdb-input v-model="editingProduct.name" invalidFeedback="Please enter a name." label="Name"
                           placeholder="Product Name" required
                           type="text"/>
              </div>
              <div class="col-md-6">
                <mdb-input v-model="editingProduct.weight" :step="0.01" invalidFeedback="Please enter a weight"
                           label="Weight (kg)"
                           placeholder="Weight" required
                           type="number"/>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-6">
                <mdb-input v-model="editingProduct.sku" label="SKU" placeholder="SKU #" type="text"/>
              </div>
              <div class="col-md-6">
                <mdb-input v-model="editingProduct.upc" label="UPC" placeholder="UPC #" type="text"/>
              </div>
            </div>

            <mdb-row>
              <div v-for="(image,i) in editingProduct.images" :id="'image-'+i" :key="i"
                   class="col-md-3 d-flex align-self-stretch">
                <mdb-card class="face front mb-4 animated rotateIn">
                  <mdb-view hover zoom>
                    <mdb-card-image
                      :src="image.thumb"
                      alt="Card image cap"
                    ></mdb-card-image>
                    <mdb-mask flex-center overlay="white-slight" waves></mdb-mask>
                  </mdb-view>
                  <mdb-card-body class='text-center'>
                    <mdb-badge v-if="image.isDefault" color="danger">Default</mdb-badge>
                    <mdb-btn v-if="!image.isDefault" rounded size="sm" @click="makeDefault(image)">Make Default
                    </mdb-btn>
                  </mdb-card-body>
                </mdb-card>
              </div>
            </mdb-row>

            <mdb-btn v-if="!showUploader && editingProduct.id" icon="image" rounded size="sm"
                     @click="showUploader=true">Add Image(s)
            </mdb-btn>
            <mdb-file-upload v-if="showUploader" :files="newFiles" accept="image/png, image/jpeg"
                             multiple @change="handleImageChange"/>
            <mdb-btn v-if="readyToUpload" icon="image" rounded size="sm" @click="uploadImages">Upload Now</mdb-btn>

            <div class="form-row mb-4">
              <div class="col-md-12">
                <div class="editor-label">Product Tags</div>
                <vue-tags-input
                  v-model="tag"
                  :autocomplete-items="filteredItems"
                  :tags="editingProduct.tags"
                  avoid-adding-duplicates
                  @before-adding-tag="addTag"
                  @tags-changed="newTags => editingProduct.tags = newTags"
                />
              </div>
            </div>

            <div class="form-row">
              <div class="col-md-12">
                <div class="editor-label">Description</div>
                <editor v-model="editingProduct.description" :init="editorConfig"/>
              </div>
            </div>
            <mdb-btn id="invalidCheck" icon="save" type="submit" @click="save">Save</mdb-btn>
          </form>

        </mdb-card-body>
      </mdb-card>
    </div>
  </mdb-container>
</template>

<script>
import dataTable from '../common/DataTable'
import api from '../../services/groupsPlaceApi.js'
import yesNoModal from "../common/YesNoModal";
import mdbFileUpload from 'mdbvue-file-upload'
import gpSelect from "../common/GPSelect";
import editor from '@tinymce/tinymce-vue'
import VueTagsInput from '@johmun/vue-tags-input';
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardImage,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbRow,
  mdbTbl,
  mdbTblBody,
  mdbTblHead,
  mdbView
} from 'mdbvue';

export default {
  name: 'products',
  components: {
    mdbContainer, mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbInput,
    mdbIcon,
    dataTable,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardImage,
    mdbRow,
    mdbCol,
    mdbMask,
    mdbView,
    mdbBadge,
    mdbTbl,
    mdbTblBody,
    mdbTblHead,
    mdbFileUpload,
    yesNoModal,
    editor,
    gpSelect,
    VueTagsInput,
    Treeselect
  },
  computed: {
    filteredItems() {
      return this.autocompleteItems.filter(i => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
      });
    },
    userDetails: function () {
      return this.$store.state.userDetails
    }

  },
  data() {
    return {
      cardConfig: {imageField: "defaultImage", textField: "name", badge: "category"},
      newFiles: [],
      showUploader: false,
      readyToUpload: false,
      currentProduct: null,
      gotError: false,
      editingProduct: null,
      views: {list: true, product: false},
      deleteCandidate: null,
      tag: '',
      autocompleteItems: [],
      editorConfig: {
        browser_spellcheck: true,
        branding: false,
        plugins: ["link", "code", "paste", "table", "lists"],
        toolbar: ["undo redo cut copy paste bold italic underline numlist bullist fontsizeselect | alignleft alignright aligncenter | link unlink code "],
        style_formats_merge: true,
        paste_as_text: true,
        relative_urls: false,
        remove_script_host: false,
        height: 400
      },
      categories: []
    }
  }
  ,
  mounted() {
    if (this.$route.params.id) {
      let row = {id: this.$route.params.id}
      this.showProduct(row)
    }
    api.get("/product/categoryTree").then(
      (results) => {
        this.categories = results.data
      },
      (error) => {
        this.$notify.error({message: error.response.data, timeOut: 20000})
      })

    api.get("/product/tags").then(
      (results) => {
        this.autocompleteItems = results.data
      },
      (error) => {
        this.$notify.error({message: error.response.data, timeOut: 20000})
      })

  }
  ,
  methods: {
    addTag(obj) {
      obj.tag.text = obj.tag.text.toLowerCase()
      let exists = false
      for (let i of this.autocompleteItems) {
        if (i.text == obj.tag.text) exists = true
      }
      if (!exists) this.autocompleteItems.push(obj.tag)
      obj.addTag()
    },
    handleImageChange(x) {
      if (this.newFiles.length > 0) this.readyToUpload = true
      else this.readyToUpload = false
    },
    checkForm(event) {
      event.target.classList.add('was-validated');
      return false;
    },
    async uploadImages() {
      this.readyToUpload = false
      this.showUploader = false
      let doReloadList = this.editingProduct.images.length == 0
      await this.$store.dispatch("setExecuting", true)
      this.gotError = false
      for (let i = 0; i < this.newFiles.length; i++) {
        if (!this.gotError) {
          let image = this.newFiles[i]
          await api.postImage("/product/image/" + this.editingProduct.id, image).then(
            (results) => {
              this.editingProduct.images.unshift(results.data)
              if (doReloadList) {
                this.$refs.productList.loadData()
                doReloadList = false
              }

            },
            (error) => {
              this.gotError = true
              this.showUpload = true
              this.$notify.error({message: error.response.data, timeOut: 5000})
              this.$store.dispatch("setExecuting", false)
            })
        }
      }
      this.newFiles = []
      await this.$store.dispatch("setExecuting", false)
    },
    save() {
      if (!this.editingProduct.name) return

      if (!this.editingProduct.description) {
        this.$notify.error({message: "Product description is required.", timeOut: 2000})
        return
      }

      this.$store.dispatch("setExecuting", true)
      api.post("/product/save", this.editingProduct).then(
        (results) => {
          this.$notify.success({message: "Saved."})
          this.editingProduct = results.data
          this.newFiles = []
          this.showUploader = false
          this.$refs.productList.loadData()
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },

    makeDefault(img) {
      this.$store.dispatch("setExecuting", true)
      api.post("/product/defaultImage/" + this.editingProduct.id, img).then(
        (results) => {
          for (let i = 0; i < this.editingProduct.images.length; i++) {
            this.editingProduct.images[i].isDefault = false
          }
          img.isDefault = true
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },

    addProduct() {
      this.editingProduct = {
        id: null,
        name: "",
        description: "",
        weight: 0,
        defaultImage: null,
        disabled: false,
        sku: "",
        upc: "",
        images: []
      }
      this.showUploader = false
      this.toggleView("product")
    }
    ,
    toggleView(view) {
      for (const v in this.views) {
        if (view == v) this.views[v] = true
        else this.views[v] = false
      }
      if (view != "list") {
        this.$nextTick().then(() => {
          window.scrollTo(0, this.listScrollPos)
        })
      }
    }
    ,
    showProduct: function (row) {
      this.$store.dispatch("setExecuting", true)
      api.get("/product/show/" + row.id).then(
        (response) => {
          this.editingProduct = response.data
          this.newFiles = []
          this.showUploader = false
          this.toggleView("product")
        },
        (error) => {
          this.showModal = false
          this.$notify.error({
                               message: "Error retrieving product. " + error.response.status,
                               timeOut: 5000,
                               position: 'top center'
                             })
        }
      ).then(() => {
        this.$store.dispatch("setExecuting", false)
      });
    }

  }

}
;
</script>
